<div
  class="tour-overlay"
  *ngIf="visible"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="'tour-title'"
  [class.visible]="visible"
  [class.has-spotlight]="spotlight.visible"
  (click)="onOverlayClick($event)">

  <div
    class="tour-spotlight"
    *ngIf="spotlight.visible"
    [style.left]="spotlight.left"
    [style.top]="spotlight.top"
    [style.width]="spotlight.width"
    [style.height]="spotlight.height"
    aria-hidden="true"></div>

  <div
    class="tour-card-wrapper"
    [class.centered]="centered"
    [style.left]="centered ? null : cardLeft"
    [style.top]="centered ? null : cardTop">
    <div class="tour-card">
      <button
        type="button"
        class="tour-close"
        (click)="skip()"
        aria-label="Cerrar guía">
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>

      <div class="tour-card-top">
        <div class="tour-step-icon" aria-hidden="true">
          <i class="fas" [ngClass]="step.icon"></i>
        </div>
        <div class="tour-meta">
          <span class="tour-kicker">{{ tourName }}</span>
          <span class="tour-progress-label">{{ progressLabel }}</span>
        </div>
      </div>

      <h2 id="tour-title" class="tour-title">{{ step.title }}</h2>

      <div class="tour-copy">
        <p class="tour-text">{{ step.text }}</p>
        <p class="tour-text tour-text-secondary" *ngIf="step.textSecondary">{{ step.textSecondary }}</p>
        <ul class="tour-tips" *ngIf="step.tips?.length">
          <li *ngFor="let tip of step.tips">
            <i class="fas fa-check" aria-hidden="true"></i>
            <span>{{ tip }}</span>
          </li>
        </ul>
      </div>

      <div class="tour-progress" [attr.aria-label]="progressLabel">
        <span
          *ngFor="let s of steps; let i = index"
          [class.active]="i === currentStep"
          [class.done]="i < currentStep"></span>
      </div>

      <label class="tour-remember" *ngIf="currentStep === steps.length - 1 || currentStep === 0">
        <input type="checkbox" [(ngModel)]="dontShowAgain" />
        <span>No volver a mostrar automáticamente</span>
      </label>

      <div class="tour-actions">
        <button type="button" class="btn-skip" (click)="skip()">Omitir</button>
        <div class="tour-actions-right">
          <button
            type="button"
            class="btn-prev"
            *ngIf="currentStep > 0"
            (click)="prev()">
            Atrás
          </button>
          <button type="button" class="btn-next" (click)="next()">{{ nextLabel }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
